(() => {
  const selector = '.jdgm-preview-badge .jdgm-prev-badge';
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll(selector).forEach(badge => {
      const rating = Number(badge.dataset.averageRating);
      const count = Number(badge.dataset.numberOfReviews);
      const empty = !(rating > 0 && count > 0);
      badge.classList.toggle('funto-rating-empty', empty);
      if (empty) return;
      const text = badge.querySelector('.jdgm-prev-badge__text');
      if (!text) return;
      let score = badge.querySelector('.funto-rating-score');
      if (!score) {
        score = document.createElement('span');
        score.className = 'funto-rating-score';
        text.before(score);
      }
      const label = rating.toFixed(1) + '/5';
      if (score.textContent !== label) score.textContent = label;
      badge.classList.add('funto-rating-ready');
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  update();
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['data-average-rating', 'data-number-of-reviews']
  });
})();
